import { render } from "./ImportacaoPedidoAgesul.vue?vue&type=template&id=3c0df28f"
import script from "./ImportacaoPedidoAgesul.vue?vue&type=script&lang=ts"
export * from "./ImportacaoPedidoAgesul.vue?vue&type=script&lang=ts"
script.render = render

export default script